import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LanguageService } from '../services/language.service';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {

  constructor(private languageService: LanguageService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentLanguage = this.languageService.getCurrentLanguage();

    const modifiedRequest = request.clone({
      setHeaders: {
        'X-Language': currentLanguage
      }
    });

    return next.handle(modifiedRequest);
  }
}
